module.exports = __webpack_public_path__ + "img/facts_1958.2947055a.jpg";